var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMainLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 5.55789C13.8147 5.55789 5.5579 13.8147 5.5579 24C5.5579 34.1853 13.8147 42.4421 24 42.4421C31.7732 42.4421 38.4283 37.6309 41.1405 30.8211H24C22.4652 30.8211 21.2211 29.5769 21.2211 28.0421C21.2211 26.5073 22.4652 25.2632 24 25.2632H40.7281C44.6859 25.2632 47.8979 28.6141 46.5175 32.3234C46.4188 32.5886 46.3159 32.8515 46.2089 33.112C42.6211 41.847 34.0319 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C34.0319 0 42.6211 6.15295 46.2089 14.888C46.3159 15.1485 46.4188 15.4114 46.5175 15.6766C47.8979 19.3859 44.6859 22.7368 40.7281 22.7368H24C22.4652 22.7368 21.2211 21.4927 21.2211 19.9579C21.2211 18.4231 22.4652 17.1789 24 17.1789H41.1405C38.4283 10.3691 31.7732 5.55789 24 5.55789Z",
  fill: "#FFE305"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.1405 17.1789C38.4283 10.3691 31.7732 5.55789 24 5.55789V0C33.7508 0 42.1386 5.81295 45.8956 14.1599C46.8238 16.3754 43.2929 17.1789 41.1405 17.1789Z",
  fill: "url(#paint0_linear_22_477)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.1405 30.8211C38.4283 37.6309 31.7732 42.4421 24 42.4421V48C33.7508 48 42.1386 42.187 45.8956 33.8401C46.8238 31.6246 43.2929 30.8211 41.1405 30.8211Z",
  fill: "url(#paint1_linear_22_477)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_22_477",
  x1: 44.2095,
  y1: 17.1789,
  x2: 24.9345,
  y2: 5.2911,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B39F04"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B39F04",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_22_477",
  x1: 44.2095,
  y1: 30.8211,
  x2: 24.9345,
  y2: 42.7089,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B39F04"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B39F04",
  stopOpacity: 0
})))));
export default SvgMainLogo;